import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { imageBaseURL } from "../../actions/Base_URL";

const Carousel = () => {
  const [current, setCurrent] = useState(0);
  const [slides, setSlides] = useState([]);
  const slideInterval = useRef(null);
  const intervalTime = 4000; // 4 seconds

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const response = await axios.get("https://api.nvcti.in/api/images/images?type=slide");
        let imagesData = [];
        if (response.data && Array.isArray(response.data.images)) {
          imagesData = response.data.images;
        } else if (Array.isArray(response.data)) {
          imagesData = response.data;
        } else if (response.data && Array.isArray(response.data.data)) {
          imagesData = response.data.data;
        }

        if (imagesData.length > 0) {
          const slideUrls = imagesData
            .filter(img => img.path) // Ensure path exists
            .map(img => `${imageBaseURL}${img.path}`);
          setSlides(slideUrls);
        }
      } catch (error) {
        console.error("Failed to fetch slides:", error);
      }
    };

    fetchSlides();
  }, []);

  // Auto-slide logic
  useEffect(() => {
    if (slides.length > 0) {
      startAutoSlide();
    }
    return () => stopAutoSlide();
  }, [current, slides.length]);

  const startAutoSlide = () => {
    stopAutoSlide();
    if (slides.length > 0) {
      slideInterval.current = setInterval(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
      }, intervalTime);
    }
  };

  const stopAutoSlide = () => {
    if (slideInterval.current) {
      clearInterval(slideInterval.current);
    }
  };

  const goToSlide = (idx) => {
    setCurrent(idx);
  };

  if (slides.length === 0) {
    return null; // Or a loading spinner/placeholder
  }

  return (
    <div style={styles.carouselContainer}>
      <div style={styles.slideWrapper}>
        {slides.map((img, idx) => (
          <div key={idx} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: idx === current ? 1 : 0, zIndex: idx === current ? 2 : 1, transition: 'opacity 0.8s cubic-bezier(0.4,0,0.2,1)' }}>
            <img
              src={img}
              alt={`slide-${idx}`}
              style={styles.slideImage}
            />
            <div style={styles.imageOverlay}></div>
          </div>
        ))}
      </div>
    </div >
  );
};

const styles = {
  carouselContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '100vw',
    // height removed to allow flex box calculation
    // overflow removed from here to allow indicators to exist naturally
    margin: '0 auto',
    background: '#111827', // dark-secondary or similar dark bg
    display: 'flex',
    flexDirection: 'column',
  },
  slideWrapper: {
    width: '100%',
    height: '70vh', // Fixed height for images
    position: 'relative',
    overflow: 'hidden', // clips the images
  },
  slideImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'opacity 0.8s cubic-bezier(0.4,0,0.2,1)',
  },
  imageOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0,0,0,0.25)',
    pointerEvents: 'none',
    zIndex: 3,
  },
  indicatorWrapper: {
    position: 'relative', // Changed from absolute
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    padding: '24px 0',
    zIndex: 10,
    background: '#111827', // continuous background
  },
  indicator: {
    height: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    display: 'inline-block',
  },
};

export default Carousel;
